import { Factory, TrialPeriodLength } from '../..';

export enum PersonalCodeValidBoundsType {
  Range = 'Range',
  SpecificDurations = 'SpecificDurations',
}

export class PersonalCodeValidBounds {
  type: PersonalCodeValidBoundsType;
  constructor(json: any) {
    this.type = json.type;
  }

  public static getFactory(): Factory<PersonalCodeValidBounds> {
    return new (class implements Factory<PersonalCodeValidBounds> {
      make(json: any): PersonalCodeValidBounds {
        switch (json.type) {
          case PersonalCodeValidBoundsType.Range:
            return new PersonalCodeValidBoundsRange(json);
          case PersonalCodeValidBoundsType.SpecificDurations:
            return new PersonalCodeValidBoundsSpecificDurations(json);
          default:
            throw new Error('Unrecognized PersonalCodeValidBounds type (' + json.type + ').');
        }
      }

      getTableName(): string {
        return 'PersonalCodeValidBounds are never stored in IndexedDB.';
      }
    })();
  }
}

export class PersonalCodeValidBoundsRange extends PersonalCodeValidBounds {
  min: TrialPeriodLength;
  max: TrialPeriodLength;

  constructor(json: any) {
    super(json);
    this.min = json.min;
    this.max = json.max;
  }
}

export class PersonalCodeValidBoundsSpecificDurations extends PersonalCodeValidBounds {
  validDurations: TrialPeriodLength[];

  constructor(json: any) {
    super(json);
    this.validDurations = json.validDurations;
  }
}
